export default {
  amountDue: "Amount Due",
  amountPaid: "Amount Paid",
  amountPaying: "Amount Paying",
  billTo: "Bill to",
  contactForPayment: "Please contact {{organization}} for payment details.",
  howToPay: "How to pay",
  currency: "Currency",
  discount: "Discount",
  due: "Due",
  editCustomAmount: "Edit custom amount",
  fees: "Fees",
  from: "From",
  invalidPaymentLink: "Invalid payment link",
  invoiceFor: "Invoice for",
  invoiceTotal: "Invoice Total",
  issued: "Issued",
  partiallyPaid: "partially paid",
  payLead: "Pay securely by card.",
  payThisInvoice: "Pay this invoice",
  paymentsSecure: "Payments are secure and encrypted",
  processingFeeTooltip: "Card processing fee charged by the payment network.",
  processingPayment: "Processing payment…",
  securePayment: "Secure payment",
  setAmount: "Set Amount",
  subtotal: "Subtotal",
  payCustomAmount: "Pay a custom amount",
  payFullAmount: "Pay full amount",
  paymentAmount: "Payment Amount",
  pay: "Pay",
  tax: "Tax",
  total: "Total",
  totalAmountPaying: "Total Amount Paying",
  totalCharge: "Total charge",
  unpaid: "unpaid",
};
